"use client";
import { useGetPictures } from "@/lib/hooks/admin-dashboard/gallery/get/useGetPictures";
import React from "react";
import GalleryHeader from "./GalleryHeader";
import Image from "next/image";
import { Button } from "@/components/ui/button";
import { Trash } from "lucide-react";
import { useDeletePictureFromGallery } from "@/lib/hooks/admin-dashboard/gallery/delete/useDeletePictureFromGallery";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const Gallery = ({ showHeader }: { showHeader?: boolean }) => {
    const { data, isLoading } = useGetPictures();
    const { mutate: deletePictureFromGallery } = useDeletePictureFromGallery();
    if (isLoading) return <p>Loading...</p>;
    const pictures = data as Gallery[];
    return (
        <main className="flex flex-col gap-10 p-10">
            {showHeader && <GalleryHeader />}
            <div className="flex w-full justify-center">
                <h1 className="text-4xl">
                Our Gallery 
                </h1>
            </div>
            <div className="columns-4 xl:columns-5 gap-10">
                {pictures && pictures.length > 0 ? pictures.map((picture) => (
                    <aside key={picture._id} className="flex flex-col gap-1">
                        <Dialog>
                            <DialogTrigger>
                                <Image
                                    src={picture.imageUrl}
                                    alt={picture.name}
                                    height={1000}
                                    width={1000}
                                    className="object-cover rounded-lg"
                                />
                            </DialogTrigger>
                            <DialogContent>
                                <DialogTitle>{""}</DialogTitle>
                                <Image
                                    src={picture.imageUrl}
                                    alt={picture.name}
                                    height={1000}
                                    width={1000}
                                    className="object-cover rounded-lg"
                                />
                                {
                                    showHeader && (
                                        <div className="flex justify-end">
                                            <Button variant={'ghost'} onClick={() => deletePictureFromGallery(picture._id)}><Trash className="h-4 w-4 text-red-500" /></Button>
                                        </div>
                                    )
                                }
                            </DialogContent>
                        </Dialog>
                    </aside>
                )) : <p>No pictures</p>}
            </div>
        </main>
    );
};

export default Gallery;
